import { prepareGradePageTitle, prepareGradeSeoTitle, prepareGradeSeoUrlSlug, prepareGradeUrl } from '@/Module/Grade/Helper';
import type { IBreadcrumb, ICategoryPath, IGrade } from '@/Module/Grade/Model/DataModel';

const DEPTH_SLUG_PREFIX: Record<number, string> = {
  0: '',
  1: 'پایه',
  2: '',
};

const DEPTH_TITLE_PREFIX: Record<number, string> = {
  0: 'مقطع',
  1: 'پایه',
  2: 'رشته',
};

const DEPTH_TITLE_SUFFIX: Record<number, string> = {
  0: ' | ',
  1: '',
  2: '',
};

const findGradeByParent = (
  categoryPathList: ICategoryPath[],
  parentId: ICategoryPath['id'],
  parentSeoUrlSlug = '',
  parentSeoTitle = '',
  parentPageTitle = '',
  parentBreadCrumb = [] as IBreadcrumb[],
  depth = 0,
): IGrade[] => {
  const items = categoryPathList.filter(item => item.parentID === parentId && item.hierarchy_level === 0);

  return items.map(item => {
    const preparedTitle = item.childName.replace('ریاضی و فیزیک', 'ریاضی فیزیک');
    const seoUrlSlug = prepareGradeSeoUrlSlug(DEPTH_SLUG_PREFIX[depth], preparedTitle, parentSeoUrlSlug);
    const seoTitle = prepareGradeSeoTitle(DEPTH_TITLE_PREFIX[depth], preparedTitle, parentSeoTitle).replace('علوم', '');
    const pageTitle = prepareGradePageTitle(
      DEPTH_TITLE_PREFIX[depth],
      DEPTH_TITLE_SUFFIX[depth],
      preparedTitle,
      parentPageTitle,
    );
    const preparedBreadcrumb: IBreadcrumb[] = [
      ...parentBreadCrumb,
      {
        entityId: item.id,
        title: item.childName,
        link: prepareGradeUrl({
          id: item.id,
          seoUrlSlug,
        }),
      },
    ];

    const children = findGradeByParent(
      categoryPathList,
      item.childId,
      seoUrlSlug,
      seoTitle,
      pageTitle,
      preparedBreadcrumb,
      depth + 1,
    );
    const preparedId = children.length === 1 ? children[0].id : item.id;

    return {
      id: preparedId,
      title: item.childName,
      imageUrl: '',
      description: item?.description ?? '',
      summery: item?.summery ?? '',
      children: children.length > 1 ? children : [],
      pageTitle: `دروس ${pageTitle}`,
      seoTitle: `ویدیوهای آموزشی ${seoTitle}`,
      breadcrumb: preparedBreadcrumb,
      isActive: !!item?.isActive,
      seoUrlSlug,
    };
  });
};

const prepareGradeListFromCategoryPath = (categoryPathList: ICategoryPath[]): IGrade[] => {
  return findGradeByParent(categoryPathList, 21);
};

export default prepareGradeListFromCategoryPath;
